export default __webpack_public_path__ + "static/media/README.4be76d34.md";